module.exports = __webpack_public_path__ + "img/favicon.fd1b1df0.png";